<template>
    <div v-if="pgLoading" class="loadingLogo">
    <img src="/assets/img/logo/charity-logo.png" alt="children's heart logo" />
  </div>
  <div v-else class="">
    <Banner
      :background="info.image ? info.image.url : ''"
      :title="!pgLoading ? $t('auth.login') : ''"
      :subtitle="!pgLoading ? $t('auth.login') : ''"
    >
    </Banner>

    <section class="login-area grey-bg2 pt-50">
      <div class="container">
        <div class="row d-flex justify-content-center">
          <div
            class="login-section donation-form white-bg mb-30 wow fadeInUp2 animated"
            data-wow-delay=".1s"
            style="
              visibility: visible;
              animation-delay: 0.1s;
              animation-name: fadeInUp2;
            "
          >
            <div
              v-if="pgLoading"
              class="section-title text-left mb-50 webkit-animation webkit-100-500"
            ></div>
            <div
              v-if="!pgLoading"
              class="section-title text-left mb-50"
              :style="$i18n.locale == 'en' ? 'text-align: left !important' : ''"
            >
              <h6 class="text-center">
                <span :style="[locale == 'en' ? { left: 'auto' } : {}]">
                  <i class="fas fa-heart"></i>
                </span>
                {{ info.title }}
              </h6>
              <h4>{{ $t("auth.login_msg") }}</h4>
            </div>

            <div class="row payment-inner">
              <form>
                <div class="row">
                  <div class="col-12">
                    <div class="input-area mb-30">
                      <input
                        type="email"
                        class="form-control"
                        v-model="row.email"
                        :placeholder="$t('auth.email')"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="input-area mb-20">
                      <input
                        type="password"
                        class="form-control"
                        v-model="row.password"
                        :placeholder="$t('auth.password')"
                      />
                    </div>
                  </div>

                  <div class="col-6 d-flex justify-content-start">
                    <div class="input-area">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        id="checkme"
                        :style="$i18n.locale == 'en' ? 'margin-left:0px' : ''"
                      />
                      <label
                        class="form-check-label"
                        for="checkme"
                        :style="$i18n.locale == 'en' ? 'margin-left:0px' : ''"
                      >
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        {{ $t("auth.remember_me") }}
                      </label>
                    </div>
                  </div>

                  <div class="col-6 d-flex justify-content-end">
                    <router-link :to="{ name: 'forget' }">
                      {{ $t("auth.forget_password") }}
                    </router-link>
                  </div>

                  <div class="col-xl-12">
                    <button
                      type="button"
                      @click="login()"
                      :disabled="btnLoading"
                      class="theme_btn theme_btn_bg"
                    >
                      <div v-if="btnLoading">
                        <div class="loader loader-xs loader-center"></div>
                      </div>
                      <div v-if="!btnLoading">
                        {{ $t("auth.login") }} <span></span>
                      </div>
                    </button>
                  </div>

                  <div class="col-xl-12 mt-20 d-flex justify-content-start">
                    <h5>
                      {{ $t("auth.no_account") }}
                      <router-link :to="{ name: 'register' }">
                        {{ $t("auth.register") }}
                      </router-link>
                    </h5>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import iziToast from "izitoast";

export default {
  name: "Login",
  components: {
    Banner: () => import("@/components/Banner.vue"),
  },
  data() {
    return {
      row: {
        email: "",
        password: "",
        keepMeAlive: false,
      },
      locale: "ar",
      btnLoading: false,
      pgLoading: true,
      info: "",
    };
  },
  mounted() {},
  created() {
    //
    if (localStorage.getItem("locale")) {
      this.locale = localStorage.getItem("locale");
    }

    this.fetchData();
  },
  methods: {
    // Keep me alive
    keepMeAlive() {
      if (this.keepMeAlive) {
        this.keepMeAlive = false;
      } else {
        this.keepMeAlive = true;
      }
    },

    //
    fetchData() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/settings/21",
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
        },
      };
      this.$axios(options)
        .then((res) => {
          this.pgLoading = false;
          this.info = res.data.info;
        })
        .catch(() => {})
        .finally(() => {});
    },

    // Login
    login() {
      if (!this.row.password || !this.row.email) {
        alert(this.$t("app.allRequired"));
        return;
      }
      this.btnLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/auth/login",
        method: "POST",
        data: {
          email: this.row.email,
          password: this.row.password,
          keepMeAlive: this.row.keepMeAlive,
        },
      };
      this.$axios(options)
        .then((res) => {
          this.btnLoading = false;
          this.row.password = "";

          localStorage.setItem("access_token", res.data.access_token);
          localStorage.setItem("first_name", res.data.user.first_name);
          localStorage.setItem("last_name", res.data.user.last_name);
          localStorage.setItem("user_id", res.data.user.encrypt_id);
          localStorage.setItem("avatar", res.data.user.image.url);
          localStorage.setItem("ccode", res.data.user.ccode);
          localStorage.setItem("mobile", res.data.user.mobile);
          localStorage.setItem("email", res.data.user.email);
          localStorage.setItem("id_number", res.data.user.id_number);

          this.$router.push({ name: "home" });
          window.location.reload();
        })
        .catch(() => {
          this.btnLoading = false;
          this.row.password = "";
          iziToast.warning({
            icon: "ti-alert",
            title: "",
            message: this.$t("app.error_contact_us"),
          });
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn-size {
  cursor: pointer;
  height: 50px;
}
</style>

